import React from 'react';
import './styles.scss'

interface IPropType {
  toggled: boolean;
  onClick: () => void
  id?: string
  label?: string
}

const Switch = ({ toggled, onClick, id, label = 'TESTE' }: IPropType) => {
  const labelClassName = (() => {
    let className = 'react-switch-label'
    if(toggled) className += ' toggled'

    return className
  })();
  
  return (
    <div className="toggle-container" id={`teste-${id}`} key={id}>
      <div className="select-label-container">
        <span>{label}</span>
      </div>
      <input
        checked={toggled}
        onChange={onClick}
        className="react-switch-checkbox"
        id={`react-switch-new-${id}`}
        type="checkbox"
      />
      <label className={labelClassName} htmlFor={`react-switch-new-${id}`}>
        <span className={`react-switch-button`} />
      </label>
    </div>
  );
};

export default Switch;